module.exports = "<p>\n  email-contact works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/email-contact/email-contact.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/email-contact/email-contact.component.html
// module chunks = main